// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"196a1fc4","293":"619c852c","422":"e3bb917c","816":"0f70f799"}[chunkId] + ".chunk.js";
};